import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactiveButton from "reactive-button";
import { toast } from "react-toastify";
import AuthClient from "../../api/AuthClient";
import GroupStatus from "../../api/enums/GroupStatus";
import RequestBetterPhotosApi from "../../api/RequestBetterPhotosApi";
import { routes } from "../../routes/routes";

type RequestBetterPhotosState = "idle" | "loading" | "success" | "error";

interface PromoterGroupActionsProps {
  city: string | undefined;
  groupId: string | undefined;
  groupStatus: GroupStatus | undefined;
  returnTo: string;
}

const PromoterGroupActions: React.FC<PromoterGroupActionsProps> = ({
  city,
  groupId,
  groupStatus,
  returnTo,
}) => {
  const navigate = useNavigate();
  const [requestBetterPhotosState, setRequestBetterPhotosState] =
    useState<RequestBetterPhotosState>("idle");

  const shouldShowPromoterActions = groupStatus === GroupStatus.Looking;

  const makeOffer = () => {
    if (!groupId) {
      return;
    }

    navigate(routes.MakeOffer(city, groupId), {
      state: {
        returnTo,
      },
    });
  };

  const requestBetterPhotos = async () => {
    if (!groupId || requestBetterPhotosState === "loading") {
      return;
    }

    const api = new RequestBetterPhotosApi(new AuthClient());

    try {
      setRequestBetterPhotosState("loading");
      const response = await api.requestBetterPhotos(groupId);

      if (!response || response.statusCode >= 400) {
        throw new Error("Failed to request better photos.");
      }

      setRequestBetterPhotosState("success");
    } catch (error) {
      console.error("Failed to request better photos:", error);
      setRequestBetterPhotosState("error");
      toast.error("Failed to request better photos.", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  if (!shouldShowPromoterActions) {
    return null;
  }

  return (
    <div className="col-12 col-sm-6 promoter-detail-actions">
      <div className="promoter-detail-actions__button">
        <ReactiveButton
          buttonState={requestBetterPhotosState}
          onClick={() => {
            void requestBetterPhotos();
          }}
          color="red"
          idleText="REQUEST BETTER PHOTOS"
          loadingText="REQUESTING"
          successText="REQUESTED"
          errorText="ERROR"
          type="button"
          className="btn btn-sm btn-outline-danger"
          outline={true}
          shadow={false}
          rounded={false}
          size="small"
          block={false}
          messageDuration={2000}
          disabled={requestBetterPhotosState === "loading" || !groupId}
          buttonRef={null}
          width={null}
          height={null}
          animation={true}
        />
      </div>
      <div className="promoter-detail-actions__button">
        <button className="btn btn-sm btn-outline-warning" onClick={makeOffer}>
          Make Offer
        </button>
      </div>
    </div>
  );
};

export default PromoterGroupActions;
